import { render } from "./FiltrosIndicadoresProjetos.vue?vue&type=template&id=1d585920&scoped=true"
import script from "./FiltrosIndicadoresProjetos.vue?vue&type=script&lang=js"
export * from "./FiltrosIndicadoresProjetos.vue?vue&type=script&lang=js"

import "./FiltrosIndicadoresProjetos.vue?vue&type=style&index=0&id=1d585920&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d585920"]])

export default __exports__